import { setDisplayName } from 'recompose';
import styled from 'styled-components';
import { Sans } from './core';
/**
 * This is for component and layout headings.
 */ export const ProductiveHeading01 = setDisplayName('ProductiveHeading01')(styled(Sans)`
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 600;
`);
/**
 * This is for component and layout headings.
 */ export const ProductiveHeading02 = setDisplayName('ProductiveHeading02')(styled(ProductiveHeading01)`
  font-size: 1rem;
  line-height: 1.375rem;
`);
/**
 * This is for component and layout headings.
 */ export const ProductiveHeading03 = setDisplayName('ProductiveHeading03')(styled(ProductiveHeading02)`
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 400;
`);
/**
 * This is for layout headings.
 */ export const ProductiveHeading04 = setDisplayName('ProductiveHeading04')(styled(ProductiveHeading03)`
  font-size: 1.75rem;
  line-height: 2.25rem;
`);
/**
 * This is for layout headings.
 */ export const ProductiveHeading05 = setDisplayName('ProductiveHeading05')(styled(ProductiveHeading04)`
  font-size: 2rem;
  line-height: 2.5rem;
`);
/**
 * This is for layout headings.
 */ export const ProductiveHeading06 = setDisplayName('ProductiveHeading06')(styled(ProductiveHeading05)`
  font-size: 2.625rem;
  line-height: 3.125rem;
  font-weight: 300;
`);
/**
 * This is for layout headings.
 */ export const ProductiveHeading07 = setDisplayName('ProductiveHeading07')(styled(ProductiveHeading06)`
  font-size: 3.375rem;
  line-height: 4rem;
`);
